import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthProvider";
import { AppContext } from "../context/AppProvider";

export default function useCin7Data() {
  const [brands, setBrands] = useState([]);
  const [categories, setCategories] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [unitsOfMeasure, setUnitsOfMeasure] = useState([]);

  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [brandsRes, suppliersRes, unitsRes, categoriesRes] =
          await Promise.all([
            fetch("/api/cin7/brands", {
              headers: { "x-access-token": authContext.getToken() },
            }),
            fetch("/api/cin7/suppliers", {
              headers: { "x-access-token": authContext.getToken() },
            }),
            fetch("/api/cin7/units-of-measure", {
              headers: { "x-access-token": authContext.getToken() },
            }),
            fetch("/api/cin7/categories", {
              headers: { "x-access-token": authContext.getToken() },
            }),
          ]);

        const brandsJson = await brandsRes.json();
        const suppliersJson = await suppliersRes.json();
        const unitsOfMeasureJson = await unitsRes.json();
        const categoriesJson = await categoriesRes.json();

        setBrands(brandsJson.map((b) => ({
          label: b.Name,
          value: b.Name,
        })));
        setSuppliers(
          suppliersJson.map((s) => ({
            label: s.Name,
            value: s.ID,
          }))
        );
        setUnitsOfMeasure(unitsOfMeasureJson);
        setCategories(categoriesJson.map((c) => ({
          label: c.Name,
          value: c.Name,
        })));
      } catch (err) {
        console.error("Error loading brands/suppliers", err);
        appContext.showMessage("Error loading Cin7 or Shopify data", "error");
      }
    };

    fetchData();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    brands,
    categories,
    suppliers,
    unitsOfMeasure,
  };
}
